import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Box from '@material-ui/core/Box'

import Close from '@material-ui/icons/Close'

import React, { useContext, useEffect, useState } from 'react'
import CustomButton from '../../CustomButton'
import CustomHeading from '../../CustomHeading'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'

export const StoresCatalogue = ({ subCategory, handleClose }) => {
  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading={'Add Stores'} />
        <IconButton color="inherit" onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </Box>
      <br />
      <Grid container>
        <Grid item lg={12}>
          <CustomSelect label={'Select Zone'} />
          <CustomInput label={'state'} />
          <CustomInput label={'City'} />
          <CustomInput label={'Store Name'} />
          <CustomInput label={'Address'} />
          <CustomInput label={'No of Employees'} />
        </Grid>
        <br />
        <Grid item lg={12}>
          <CustomButton text={'Add'} />
        </Grid>
      </Grid>
    </>
  )
}
